import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Machine from './machine-model'
import {
  CreateMachineAsync,
  DeleteMachineAsync,
  LoadMachinesAsync,
} from './machine-thunk'
const initialState: machineSliceState = {
  machine: [],
  selected_machine: '',
  is_loading_machine: false,
  is_creating_machine: false,
  is_deleting_machine: false,
}
export interface machineSliceState {
  machine: Machine[]
  selected_machine?: string
  is_loading_machine: boolean
  is_creating_machine: boolean
  is_deleting_machine: boolean
}
export const machineSlice = createSlice({
  name: 'machine',
  initialState,
  reducers: {
    setSelectedmachine: (state, action) => {
      state.selected_machine = action.payload
    },
    clearStatemachine: (state) => {
      state.machine = []
      state.is_loading_machine = false
      state.is_creating_machine = false
      state.is_deleting_machine = false
    },
    mergemachine: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_machine = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.machine = merge(state.machine, payload) as any
        }
      }
    },

    add_machine: (state, action) => {
      if (action.payload) {
        state.machine = [...state.machine, action.payload]
      }
    },
    set_machine: (state, action) => {
      let { key, value, id } = action.payload
      state.machine = state.machine.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMachinesAsync.pending, (state) => {
      state.is_loading_machine = true
    })
    builder.addCase(LoadMachinesAsync.fulfilled, (state, action) => {
      state.is_loading_machine = false
      if (action.payload) {
        state.machine = action.payload
      }
    })
    builder.addCase(LoadMachinesAsync.rejected, (state) => {
      state.is_loading_machine = false
    })
    builder.addCase(CreateMachineAsync.pending, (state) => {
      state.is_creating_machine = true
    })
    builder.addCase(CreateMachineAsync.fulfilled, (state) => {
      state.is_creating_machine = false
    })
    builder.addCase(CreateMachineAsync.rejected, (state) => {
      state.is_creating_machine = false
    })
    builder.addCase(DeleteMachineAsync.pending, (state) => {
      state.is_deleting_machine = true
    })
    builder.addCase(DeleteMachineAsync.fulfilled, (state, action) => {
      state.is_deleting_machine = false
      if (state.machine) {
        state.machine = state.machine.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteMachineAsync.rejected, (state) => {
      state.is_deleting_machine = false
    })
  },
})

export const {
  clearStatemachine,
  setSelectedmachine,
  set_machine,
  mergemachine,
  add_machine,
} = machineSlice.actions

export const get_machine =
  (id?: string) =>
  (state: {
    machine: {
      machine: Machine[]
    }
  }): Machine | null => {
    let temp = state?.machine?.machine?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.machine?.machine[0] || null
  }
export const get_selected_machine = (state: {
  machine: machineSliceState
}): Machine | null => {
  let id = state?.machine?.selected_machine
  let temp = state?.machine?.machine?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_machine = (state: {
  machine: {
    machine: Machine[]
  }
}): Machine[] => {
  let temp = state?.machine?.machine
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_machine_busy = (state: { machine: machineSliceState }) => {
  return (
    state?.machine.is_deleting_machine ||
    state?.machine.is_loading_machine ||
    state?.machine.is_creating_machine
  )
}
export const is_deleting_machine_busy = (state: {
  machine: machineSliceState
}) => {
  return state?.machine.is_deleting_machine
}
export const is_loading_machine_busy = (state: {
  machine: machineSliceState
}) => {
  return state?.machine.is_loading_machine
}
export const is_creating_machine_busy = (state: {
  machine: machineSliceState
}) => {
  return state?.machine.is_creating_machine
}

export default machineSlice.reducer
